import React, { useState, useEffect } from 'react';

import './createTRF.css';
import {
    TextField, Autocomplete, Button, IconButton, InputAdornment
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useDispatch, useSelector } from 'react-redux';
import { Formik } from 'formik';
import * as yup from 'yup';
import { fetchBirlaFiber } from '../../../redux/trfUserSlice';
import { useLocation, useNavigate } from 'react-router-dom';


export const CREATE_TRF_VALIDATION = yup.object().shape({
    ItemNumber: yup.string().required('Item/ Article/ Style Number cannot be empty.'),
    supplierCompanyKeyId: yup.string().required('Supplier is required.'),
    orderDate: yup.date().required('Order date is required.'),
    orderExpectedDate: yup.date().required('Order due date is required.'),
    orderDescription: yup.string().required('Order description is required.'),
});

const CreateTRF = () => { 
   
    const [initialState, setInitialState] = useState({
    });
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const location = useLocation();

    const birlaFibreList = useSelector(state => state.trfUser.getBirlaFiber || []);
    const birlaFibreOptions = birlaFibreList.map(birlaFibre => ({
        label: birlaFibre.fibre_name,
        value: birlaFibre.fibre_name,
    }));

    const productTypeList = useSelector(state => state.order.suppliers.data || []);
    const productTypeOptions = productTypeList.map(productType => ({
        label: Product_Type,
        value: ProductType,
    }));

    const productDetailsList = useSelector(state => state.order.suppliers.data || []);
    const productDetailsOptions = productDetailsList.map(productDetails => ({
        label: ProductDetails_Type,
        value: ProductDetailsType,
    }));

    const claimedCompositionList = useSelector(state => state.order.suppliers.data || []);
    const claimedCompositionOptions = claimedCompositionList.map(claimedComposition => ({
        label: Claimed_Composition,
        value: ClaimedComposition,
    }));

    const garmenterList = useSelector(state => state.order.suppliers.data || []);
    const garmenterOptions = garmenterList.map(garmenter => ({
        label: Garmenter,
        value: Garmenter,
    }));

    const finishedFabricManufacturerList = useSelector(state => state.order.suppliers.data || []);
    const finishedFabricManufacturerOptions = finishedFabricManufacturerList.map(finishedFabricManufacturer => ({
        label: FinishedFabricManufacturer,
        value: FinishedFabricManufacturer,
    }));

    const greigeFabricManufacturerList = useSelector(state => state.order.suppliers.data || []);
    const greigeFabricManufacturerOptions = greigeFabricManufacturerList.map(greigeFabricManufacturer => ({
        label: GreigeFabricManufacturer,
        value: GreigeFabricManufacturer,
    }));

    const spinnerList = useSelector(state => state.order.suppliers.data || []);
    const spinnerOptions = spinnerList.map(spinner => ({
        label: Spinner,
        value: Spinner,
    }));

    const testingLabLocationList = useSelector(state => state.order.suppliers.data || []);
    const testingLabLocationOptions = testingLabLocationList.map(spinner => ({
        label: Testing_Lab_Location,
        value: TestingLabLocation,
    }));
    useEffect(() => {
        console.log("Get Birla Fiber",birlaFibreList)
        dispatch(fetchBirlaFiber());
    }, [dispatch]);
    return(
        <>

            <div className="main-content">
                {/* Breadcrumb, progress bar, and other UI elements */}
                <nav aria-label="breadcrumb" className="bread-box">
                <div>
                    <h1 className="fprimary">Create Tracer Test</h1>
                    <h5 className="">Please note: Kindly fill in all details in English characters only and within character</h5>
                     <h5 className="">limits as specified in the form below. Fields marked with asterisk(*) are mendatory</h5>
                </div>
                <div>
                    <ol className="breadcrumb">
                    <li className="breadcrumb-item"><a href="#">Home</a></li>
                    <li className="breadcrumb-item active" aria-current="page">Create Tracer Test</li>
                    </ol>
                </div>
                </nav>
                <div className="card mt-3 bg-stage bg-dot">
                    <div className="card-body">
                       <div className="createTRF">
                            <div className="row" style={{marginTop:"32px"}}>
                                    <h4 className="createTrfApplicantName">
                                        Applicant Name: <span className="createTrfApplicantNameSpan" >Brand India Ltd</span>
                                    </h4>
                            </div>
                            <div className="row">
                                    <h4 className="createTrfApplicantName">
                                        Today Date: <span className="createTrfApplicantNameSpan" >18 February 2024</span>
                                    </h4>
                            </div>
                       </div>
                       <Formik
                            initialValues={initialState}
                            enableReinitialize
                            validationSchema={CREATE_TRF_VALIDATION}
                            onSubmit={(values, { setSubmitting }) => {
                                const formattedValues = {
                                    ...values,
                                    // orderDate: values.orderDate.format('YYYY-MM-DD'),
                                    // orderExpectedDate: values.orderExpectedDate.format('YYYY-MM-DD'),
                                };
                                onSubmit(formattedValues);
                                setSubmitting(false);
                            }}
                        >{({ values, errors, handleChange, handleBlur, handleSubmit, setFieldValue, touched }) => (
                            <form onSubmit={handleSubmit}>
                       <div className="row">
                            <div className="col-md-6 cs-form mb-3">
                                    <TextField
                                        //label={t('createOrder.purchaseOrder')}
                                        label='Item/Article/Style Number*'
                                        className='md-input'
                                        name='invoiceNumber'
                                        value={values.invoiceNumber}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={errors.invoiceNumber}
                                        helperText={errors.invoiceNumber}
                                    />
                            </div>
                            <div className="col-md-6 cs-form mb-3">
                                <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    className='md-input'
                                    style={{width:"172%"}}
                                    options={birlaFibreOptions}
                                    getOptionLabel={(option) => option.label || ''}
                                    value={birlaFibreOptions.find(option => option.value === values.birlaFibre) || null}
                                    onChange={(event, newValue) => {
                                        handleChange({ target: { name: 'birlaFibre', value: newValue?.value || '' } });
                                    }}
                                    onBlur={handleBlur}
                                    renderInput={(params) => (
                                        <TextField
                                             {...params}
                                            // label={t('createOrder.supplier')}
                                            label='Birla Fibre*'
                                            style={{width:"58%"}}
                                             error={touched.birlaFibre && Boolean(errors.birlaFibre)}
                                             helperText={touched.birlaFibre && errors.birlaFibre}
                                        />
                                    )}
                                />
                            </div>
                            <div className="col-md-12 cs-form mb-3">
                                <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    className='md-input'
                                    options={productTypeOptions}
                                    getOptionLabel={(option) => option.label || ''}
                                    value={productTypeOptions.find(option => option.value === values.supplierCompanyKeyId) || null}
                                    onChange={(event, newValue) => {
                                        handleChange({ target: { name: 'supplierCompanyKeyId', value: newValue?.value || '' } });
                                    }}
                                    onBlur={handleBlur}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            // label={t('createOrder.supplier')}
                                            label='Product Type*'
                                            fullWidth
                                            error={touched.supplierCompanyKeyId && Boolean(errors.supplierCompanyKeyId)}
                                            helperText={touched.supplierCompanyKeyId && errors.supplierCompanyKeyId}
                                        />
                                    )}
                                />
                            </div>
                        </div>
                        <div className="product details">
                            <div>
                                <h4 className="createTrfProductDetailsHeading">Product Details</h4>
                            </div>
                            <div className="row">
                                <div className="col-md-12 cs-form mb-3">
                                    <Autocomplete
                                        disablePortal
                                        id="combo-box-demo"
                                        className='md-input'
                                        options={productDetailsOptions}
                                        getOptionLabel={(option) => option.label || ''}
                                        value={productDetailsOptions.find(option => option.value === values.supplierCompanyKeyId) || null}
                                        onChange={(event, newValue) => {
                                            handleChange({ target: { name: 'supplierCompanyKeyId', value: newValue?.value || '' } });
                                        }}
                                        onBlur={handleBlur}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                // label={t('createOrder.supplier')}
                                                label='Type Here'
                                                fullWidth
                                                error={touched.supplierCompanyKeyId && Boolean(errors.supplierCompanyKeyId)}
                                                helperText={touched.supplierCompanyKeyId && errors.supplierCompanyKeyId}
                                            />
                                        )}
                                    />
                                </div>
                                <div className="col-md-6 cs-form mb-3">
                                        <TextField
                                            //label={t('createOrder.purchaseOrder')}
                                            label='Wrap & Wreft Count*'
                                            className='md-input'
                                            name='warpWeft'
                                            value={values.warpWeft}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            error={errors.warpWeft}
                                            helperText={errors.warpWeft}
                                        />
                                </div>
                                <div className="col-md-6 cs-form mb-3">
                                        <TextField
                                            //label={t('createOrder.purchaseOrder')}
                                            label='Fabric Construction*'
                                            className='md-input'
                                            name='warpWeftConstruction'
                                            value={values.warpWeftConstruction}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            error={errors.warpWeftConstruction}
                                            helperText={errors.warpWeftConstruction}
                                        />
                                </div>
                                <div className="col-md-6 cs-form mb-3">
                                        <TextField
                                            //label={t('createOrder.purchaseOrder')}
                                            label='Fabric Width(inches)*'
                                            className='md-input'
                                            name='warpWeftWidth'
                                            value={values.warpWeftWidth}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            error={errors.warpWeftWidth}
                                            helperText={errors.warpWeftWidth}
                                        />
                                </div>
                                <div className="col-md-6 cs-form mb-3">
                                        <TextField
                                            //label={t('createOrder.purchaseOrder')}
                                            label='Fabric GSM*'
                                            className='md-input'
                                            name='fabricGsm'
                                            value={values.fabricGsm}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            error={errors.fabricGsm}
                                            helperText={errors.fabricGsm}
                                        />
                                </div>
                            </div>

                        </div>

                        <div className="claimed Composition">
                            <div>
                                <h4 className="createTrfClaimedCompositionHeading">Claimed Composition of Birla Fibre is*</h4>
                            </div>
                            <div className="row">
                                <div className="col-md-12 cs-form mb-3">
                                    <Autocomplete
                                        disablePortal
                                        id="combo-box-demo"
                                        className='md-input'
                                        options={claimedCompositionOptions}
                                        getOptionLabel={(option) => option.label || ''}
                                        value={claimedCompositionOptions.find(option => option.value === values.supplierCompanyKeyId) || null}
                                        onChange={(event, newValue) => {
                                            handleChange({ target: { name: 'supplierCompanyKeyId', value: newValue?.value || '' } });
                                        }}
                                        onBlur={handleBlur}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                // label={t('createOrder.supplier')}
                                                label='100%'
                                                fullWidth
                                                error={touched.supplierCompanyKeyId && Boolean(errors.supplierCompanyKeyId)}
                                                helperText={touched.supplierCompanyKeyId && errors.supplierCompanyKeyId}
                                            />
                                        )}
                                    />
                                </div>
                                <div className="col-md-6 cs-form mb-3">
                                        <TextField
                                            //label={t('createOrder.purchaseOrder')}
                                            label='Applicant Name*'
                                            className='md-input'
                                            name='Applicant Name'
                                            value={values.orderNumber}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            error={errors.orderNumber}
                                            helperText={errors.orderNumber}
                                        />
                                </div>
                                <div className="col-md-6 cs-form mb-3">
                                        <TextField
                                            //label={t('createOrder.purchaseOrder')}
                                            label='Applicant Address'
                                            className='md-input'
                                            name='Applicant Address'
                                            value={values.orderNumber}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            error={errors.orderNumber}
                                            helperText={errors.orderNumber}
                                        />
                                </div>
                                <div className="col-md-6 cs-form mb-3">
                                        <TextField
                                            //label={t('createOrder.purchaseOrder')}
                                            label='Fabric Order Number*'
                                            className='md-input'
                                            name='Fabric Order Number'
                                            // value={values.orderNumber}
                                            // onChange={handleChange}
                                            // onBlur={handleBlur}
                                            // error={errors.orderNumber}
                                            // helperText={errors.orderNumber}
                                        />
                                </div>
                                <div className="col-md-6 cs-form mb-3">
                                        <TextField
                                            //label={t('createOrder.purchaseOrder')}
                                            label='Sample Batch Number*'
                                            className='md-input'
                                            name='Sample Batch Number'
                                            // value={values.orderNumber}
                                            // onChange={handleChange}
                                            // onBlur={handleBlur}
                                            // error={errors.orderNumber}
                                            // helperText={errors.orderNumber}
                                        />
                                </div>
                            </div>

                        </div>

                        <div className="partner details">
                            <div>
                                <h4 className="createTrfPartnerDetailsHeading">Please Note: If partner is not registered, please select option Others. If partner is unknown, please select option Others-Unknown</h4>
                            </div>
                            <div className="row">
                                <div className="col-md-6 cs-form mb-3">
                                        <TextField
                                            //label={t('createOrder.purchaseOrder')}
                                            label='Brand Name*'
                                            className='md-input'
                                            name='Brand Name'
                                            // value={values.orderNumber}
                                            // onChange={handleChange}
                                            // onBlur={handleBlur}
                                            // error={errors.orderNumber}
                                            // helperText={errors.orderNumber}
                                        />
                                </div>
                                <div className="col-md-6 cs-form mb-3">
                                    <Autocomplete
                                        disablePortal
                                        id="combo-box-demo"
                                        className='md-input'
                                        style={{width:"172%"}}
                                        options={garmenterOptions}
                                        getOptionLabel={(option) => option.label || ''}
                                        value={garmenterOptions.find(option => option.value === values.supplierCompanyKeyId) || null}
                                        onChange={(event, newValue) => {
                                            handleChange({ target: { name: 'supplierCompanyKeyId', value: newValue?.value || '' } });
                                        }}
                                        onBlur={handleBlur}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                // label={t('createOrder.supplier')}
                                                label='Garmenter*'
                                                style={{width:"58%"}}
                                                error={touched.supplierCompanyKeyId && Boolean(errors.supplierCompanyKeyId)}
                                                helperText={touched.supplierCompanyKeyId && errors.supplierCompanyKeyId}
                                            />
                                        )}
                                    />
                                </div>
                                <div className="col-md-6 cs-form mb-3">
                                    <Autocomplete
                                        disablePortal
                                        id="combo-box-demo"
                                        className='md-input'
                                        style={{width:"172%"}}
                                        options={finishedFabricManufacturerOptions}
                                        getOptionLabel={(option) => option.label || ''}
                                        value={finishedFabricManufacturerOptions.find(option => option.value === values.supplierCompanyKeyId) || null}
                                        onChange={(event, newValue) => {
                                            handleChange({ target: { name: 'supplierCompanyKeyId', value: newValue?.value || '' } });
                                        }}
                                        onBlur={handleBlur}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                // label={t('createOrder.supplier')}
                                                label='Finished Fabric Manufacturer*'
                                                style={{width:"58%"}}
                                                error={touched.supplierCompanyKeyId && Boolean(errors.supplierCompanyKeyId)}
                                                helperText={touched.supplierCompanyKeyId && errors.supplierCompanyKeyId}
                                            />
                                        )}
                                    />
                                </div>
                                <div className="col-md-6 cs-form mb-3">
                                    <Autocomplete
                                        disablePortal
                                        id="combo-box-demo"
                                        className='md-input'
                                        style={{width:"172%"}}
                                        options={greigeFabricManufacturerOptions}
                                        getOptionLabel={(option) => option.label || ''}
                                        value={greigeFabricManufacturerOptions.find(option => option.value === values.supplierCompanyKeyId) || null}
                                        onChange={(event, newValue) => {
                                            handleChange({ target: { name: 'supplierCompanyKeyId', value: newValue?.value || '' } });
                                        }}
                                        onBlur={handleBlur}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                // label={t('createOrder.supplier')}
                                                label='Greige Fabric Manufacturer*'
                                                style={{width:"58%"}}
                                                error={touched.supplierCompanyKeyId && Boolean(errors.supplierCompanyKeyId)}
                                                helperText={touched.supplierCompanyKeyId && errors.supplierCompanyKeyId}
                                            />
                                        )}
                                    />
                                </div>
                                <div className="col-md-12 cs-form mb-3">
                                    <Autocomplete
                                        disablePortal
                                        id="combo-box-demo"
                                        className='md-input'
                                        options={spinnerOptions}
                                        getOptionLabel={(option) => option.label || ''}
                                        value={spinnerOptions.find(option => option.value === values.supplierCompanyKeyId) || null}
                                        onChange={(event, newValue) => {
                                            handleChange({ target: { name: 'supplierCompanyKeyId', value: newValue?.value || '' } });
                                        }}
                                        onBlur={handleBlur}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                // label={t('createOrder.supplier')}
                                                label='Spinner*'
                                                fullWidth
                                                error={touched.supplierCompanyKeyId && Boolean(errors.supplierCompanyKeyId)}
                                                helperText={touched.supplierCompanyKeyId && errors.supplierCompanyKeyId}
                                            />
                                        )}
                                    />
                                </div>
                                <div className="col-md-6 cs-form mb-3">
                                    <Autocomplete
                                        disablePortal
                                        id="combo-box-demo"
                                        className='md-input'
                                        style={{width:"172%"}}
                                        options={testingLabLocationOptions}
                                        getOptionLabel={(option) => option.label || ''}
                                        value={testingLabLocationOptions.find(option => option.value === values.supplierCompanyKeyId) || null}
                                        onChange={(event, newValue) => {
                                            handleChange({ target: { name: 'supplierCompanyKeyId', value: newValue?.value || '' } });
                                        }}
                                        onBlur={handleBlur}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                // label={t('createOrder.supplier')}
                                                label='Testing Lab Location*'
                                                style={{width:"58%"}}
                                                error={touched.supplierCompanyKeyId && Boolean(errors.supplierCompanyKeyId)}
                                                helperText={touched.supplierCompanyKeyId && errors.supplierCompanyKeyId}
                                            />
                                        )}
                                    />
                                </div>
                                <div className="col-md-6 cs-form mb-3">
                                        <TextField
                                            //label={t('createOrder.purchaseOrder')}
                                            label='Contact email ID*'
                                            className='md-input'
                                            name='Contact email ID'
                                            // value={values.orderNumber}
                                            // onChange={handleChange}
                                            // onBlur={handleBlur}
                                            // error={errors.orderNumber}
                                            // helperText={errors.orderNumber}
                                        />
                                </div>
                                <div className="col-md-12 cs-form mb-3">
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            //label={t('createOrder.orderDate')}
                                            label='Production Date*'
                                            className='md-input'
                                            // value={values.orderDate}
                                            // onChange={(newValue) => {
                                            //     setFieldValue('orderDate', newValue);
                                            // }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    className='md-input'
                                                    fullWidth
                                                    // error={errors.orderDate}
                                                    // helperText={errors.orderDate}
                                                />
                                            )}
                                        />
                                    </LocalizationProvider>
                                </div>

                               
                            </div>
                        </div>
                        <div className="upload image">
                            <div>
                                <h4 className="createTrfUploadImageHeading">Upload Image* :</h4>
                            </div>
                            <div>
                                <Button style={{backgroundColor:"green", color:"white"}}>
                                    Upload Image
                                </Button>
                            </div>
                        </div>
                       
                        <div className="save buttons">
                            <Button style={{backgroundColor:"green", color:"white", marginLeft:"76%"}}>Save as Draft</Button>
                            <Button style={{backgroundColor:"green", color:"white", marginLeft:"6px"}}>Crete TRF</Button>
                        </div>
                        </form>
            )}
            </Formik >
                </div>
            </div>
        </div>
      
        </>
    )
}
export default CreateTRF;